<template>
    <div name="payment">
        <content1 />       
    </div>
</template>

<script>
import Content1 from '@/pages/privacy/history/Payment0204'
export default {
    name: 'payment',
    components: {Content1}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/privacy/Payment.vue